/**
 * `cn()` — class-name merger used by every shadcn/ui component.
 *
 * `clsx` resolves the conditional class-name args; `twMerge` then dedupes
 * conflicting Tailwind utility classes (so `cn('px-2', 'px-4')` → `'px-4'`
 * rather than both classes ending up in the DOM and the cascade picking
 * whichever wins). This is the shadcn convention; every shadcn component
 * imports `cn` from this path.
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
